export default __webpack_public_path__ + "static/media/71t.928ec268.jpg";